// Webpack Imports
import * as bootstrap from 'bootstrap';

(function () {
    'use strict';

    const hamburger = document.querySelector('.hamburger');
    const menu = document.querySelector('.menu');

    hamburger.addEventListener('click', () => {
        hamburger.classList.toggle('active');
        menu.classList.toggle('active');
    });

    var wow = new WOW({
        animateClass: "animated",
        offset: 100,
        callback: function (box) {
        },
    });
    wow.init();

    // Slider
    var swiper = new Swiper(".people-slide", {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        pagination: {
            el: ".swiper-pagination"
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            640: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
                loop: true
            },
            1600: {
                slidesPerView: 3,
                loop: true

            },
            1960: {
                slidesPerView: 3,
                loop: true
            },
        },
    });


// Slider
    var swiper = new Swiper(".news-slide", {
        slidesPerView: 1,
        spaceBetween: 25,
        grabCursor: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            640: {
                slidesPerView: "auto",
                // slidesPerView: 1,
                loop: true,
                spaceBetween: 25,
            },
            768: {

                slidesPerView: 2,
                spaceBetween: 25,
            },
            1600: {
                slidesPerView: 3,
                spaceBetween: 25,
            },
        },
    });

    if ('IntersectionObserver' in window) {
        document.addEventListener("DOMContentLoaded", function() {

            function handleIntersection(entries) {
                entries.map((entry) => {
                    if (entry.isIntersecting) {
                        // Item has crossed our observation
                        // threshold - load src from data-src
                        entry.target.style.backgroundImage = "url('"+entry.target.dataset.bgimage+"')";
                        // Job done for this item - no need to watch it!
                        observer.unobserve(entry.target);
                    }
                });
            }

            const headers = document.querySelectorAll('.img-container');
            const observer = new IntersectionObserver(
                handleIntersection,
                { rootMargin: "100px" }
            );
            headers.forEach(header => observer.observe(header));
        });
    } else {
        // No interaction support? Load all background images automatically
        const headers = document.querySelectorAll('.header-container');
        headers.forEach(header => {
            header.style.backgroundImage = "url('"+header.dataset.bgimage+"')";
        });
    }


    const tabs = document.querySelectorAll(".tab")
    const tabSections = document.querySelectorAll(".tab-section")

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.boundingClientRect.top < 0) {
                const index = Array.from(tabSections).indexOf(entry.target)
                tabs.forEach(tab => {
                    tab.classList.remove("active")
                })
                tabs[index].classList.add("active")
            }
        })
    }, {
        threshold: [1, 0],
        rootMargin: "0px 0px 0px 0px",
    })

    tabSections.forEach(sections => {
        observer.observe(sections)
    })


    const tabsLink = ['I am an employer', 'I am an employee', 'I’m a mental health professional'];
    const interleaveOffset = 0;
    var swiper = new Swiper('.swiper-navi', {
        direction: 'vertical',
        speed: 800,
        mousewheelControl: true,
        mousewheel: {
            releaseOnEdges: true,
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'bullets',
            renderBullet: function (index, className) {
                return '<span class="' + className + '">' + tabsLink[index] + '</span>';
            }
        },
        768: {
            autoHeight: true,
        },
        on: {
            progress: function () {
                let swiper = this;

                for (let i = 0; i < swiper.slides.length; i++) {
                    let slideProgress = swiper.slides[i].progress;
                    let innerOffset = swiper.height * interleaveOffset;
                    let innerTranslate = slideProgress * innerOffset;

                    TweenMax.set(swiper.slides[i].querySelector(".slide-inner"), {
                        y: innerTranslate,
                    });
                }
            },
            setTransition: function (slider, speed) {
                let swiper = this;
                for (let i = 0; i < swiper.slides.length; i++) {
                    swiper.slides[i].style.transition = speed + "ms";
                    swiper.slides[i].querySelector(".slide-inner").style.transition =
                        speed + "ms";
                }
            }
        }
    });

})();
